import type {
  BoxProps,
  IconProps,
  LineProps,
  RhombusProps,
  TextProps
} from "../coreComponents/types";
import type { SCNode } from "./fsc.types";

type BoxNodeProps = {
  children: SCNode[];
  key: string;
} & BoxProps;

const BoxNode = ({ children, ...props }: BoxNodeProps): SCNode => {
  return {
    componentKey: "Box",
    key: props.key,
    props,
    children: children || []
  };
};

type RhombusNodeProps = {
  children: SCNode[];
  key: string;
} & RhombusProps;

const RhombusNode = ({ children, ...props }: RhombusNodeProps): SCNode => ({
  componentKey: "Rhombus",
  key: props.key,
  props,
  children: children || []
});

type TextNodeProps = {
  children: never[];
  key: string;
} & TextProps;

const TextNode = ({ children, ...props }: TextNodeProps): SCNode => ({
  componentKey: "Text",
  key: props.key,
  props,
  children: [] // shouldn't support children
});

type IconNodeProps = {
  children: never[];
  key: string;
} & IconProps;

const IconNode = ({ children, ...props }: IconNodeProps): SCNode => ({
  componentKey: "Icon",
  key: props.key,
  props,
  children: [] // shouldn't support children
});

export const LineNode = (props: LineProps): SCNode => ({
  componentKey: "Line",
  key: props.key,
  props,
  children: []
});

export { BoxNode, IconNode, TextNode, RhombusNode };
export type { BoxNodeProps, IconNodeProps, TextNodeProps, RhombusNodeProps };
